import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Input } from '../ui/Input';
export function Step10Pages() {
  const {
    data,
    updateData
  } = useIntake();
  // Base pages for all types
  const basePages = [{
    value: 'home',
    label: 'Home'
  }, {
    value: 'contact',
    label: 'Contact'
  }, {
    value: 'legal',
    label: "Juridische pagina's (Privacy, Voorwaarden)"
  }];
  // Pages for standard website
  const websitePages = [...basePages, {
    value: 'about',
    label: 'Over ons'
  }, {
    value: 'services',
    label: 'Diensten / Producten'
  }, {
    value: 'team',
    label: 'Team'
  }, {
    value: 'faq',
    label: 'Veelgestelde vragen (FAQ)'
  }, {
    value: 'blog',
    label: 'Blog / Kennisbank'
  }, {
    value: 'cases',
    label: 'Cases / Portfolio'
  }, {
    value: 'vacancies',
    label: 'Werken bij / Vacatures'
  }, {
    value: 'other',
    label: 'Anders...'
  }];
  // Pages for webshop (includes website pages + shop specific)
  const webshopPages = [...websitePages.filter(p => p.value !== 'other'), {
    value: 'shop',
    label: 'Winkel / Productoverzicht'
  }, {
    value: 'cart',
    label: 'Winkelwagen'
  }, {
    value: 'checkout',
    label: 'Afrekenen'
  }, {
    value: 'account',
    label: 'Mijn Account'
  }, {
    value: 'other',
    label: 'Anders...'
  }];
  // Pages for onepager
  const onepagerPages = [{
    value: 'home',
    label: 'Home (Onepager)'
  }, {
    value: 'extra_page',
    label: '1 Extra pagina (bijv. diensten of over ons)'
  }, {
    value: 'blog',
    label: 'Blog / Nieuws'
  }, {
    value: 'legal',
    label: "Juridische pagina's"
  }, {
    value: 'other',
    label: 'Anders...'
  }];
  let currentOptions = websitePages;
  if (data.websiteType === 'webshop') currentOptions = webshopPages;
  if (data.websiteType === 'onepager') currentOptions = onepagerPages;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-39" data-mp="2ef5wrjpqu92e">
      <MascotPanel message="Een goede structuur is het halve werk. Welke pagina's verwacht u minimaal nodig te hebben op de nieuwe website?" data-id="element-40" data-mp="25gc4g5jg44un" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-41" data-mp="1vgbjyg9ubiov">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-42" data-mp="3kvhzly3igf4b">
          Pagina's & Structuur
        </h2>

        <div data-id="element-43" data-mp="3pucif01ha3of">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-44" data-mp="3pv4dm9r5xze6">
            Selecteer de gewenste pagina's:
          </label>
          <CheckboxGroup columns={2} options={currentOptions} values={data.neededPages} onChange={vals => updateData({
          neededPages: vals
        })} data-id="element-45" data-mp="1e7sfqzf3vn80" />

          <AnimatePresence data-id="element-46" data-mp="1j62efk01h5yd">
            {data.neededPages.includes('other') && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="mt-4 overflow-hidden" data-id="element-47" data-mp="1wxgzrxhf5j8l">
                <Input placeholder="Welke andere pagina's wilt u toevoegen?" value={data.customPageOther} onChange={e => updateData({
              customPageOther: e.target.value
            })} data-id="element-48" data-mp="chdodxvwmp02" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}